import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { ROW_TYPES } from '../Properties';
import { isPresent } from '../funcs';

const useStyles = makeStyles((theme) => ({
    icon: {
        fontSize: 16,
        paddingRight: theme.spacing(2.5),
    },
    wifiSuccess: {
        '& span': {
            color: theme.palette.status.green,
        },
    },
    wifiFail: {
        '& span': {
            color: theme.palette.status.red,
        },
    },
}));

const WirelessNetwork = ({ connected, ssid }) => {
    const classes = useStyles();
    const wirelessClass = connected ? classes.wifiSuccess : classes.wifiFail;
    return (
        <div className={wirelessClass}>
            <Icon className={classes.icon}>signal_wifi_4_bar</Icon>
            {ssid}
        </div>
    );
};

export default function wirelessNetworkProperty(connectedField, ssidField) {
    return {
        type: ROW_TYPES.FUNCTION,
        hasValue: (data) => isPresent(data?.[ssidField]),
        title: i18n._(t`Wi-Fi Network`),
        mapper: (data) => {
            const { [connectedField]: connected, [ssidField]: ssid } = data || {};
            return <WirelessNetwork connected={connected} ssid={ssid} />;
        },
    };
}
